import React, { useEffect, useState } from 'react';
import { getAllPosts, getDatePathFromIsoString } from '@/utils/blog';
import { BlogPostMetadata } from '@/types/blog';
import BlogCard from '@/components/BlogCard';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import PageMeta from '@/components/seo/PageMeta';
import { targetSeoMetadata } from '@/config/seoMetadata.js';

const BlogIndex: React.FC = () => {
  const [posts, setPosts] = useState<BlogPostMetadata[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  
  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const allPosts = await getAllPosts();
        setPosts(allPosts);
      } catch (error) {
        console.error('Error fetching posts:', error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchPosts();
  }, []);
  
  return (
    <div className="flex min-h-screen flex-col bg-gray-950">
      <PageMeta
        title={targetSeoMetadata.blogIndex.title}
        description={targetSeoMetadata.blogIndex.description}
        canonicalPath="/blog"
        keywords={['sports blog', 'spoiler-free sports', 'sports viewing', 'skore.info']}
      />
      <Header />
      
      <main className="flex-1 py-8 px-4 md:px-6">
        <div className="container mx-auto">
          <h1 className="mb-8 text-3xl md:text-4xl font-bold text-white">Latest Articles</h1>
          
          {loading ? (
            <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
              {[...Array(6)].map((_, i) => (
                <div key={i} className="h-96 animate-pulse rounded-lg bg-gray-800" />
              ))}
            </div>
          ) : posts.length > 0 ? (
            <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
              {posts.map((post) => {
                // Extract date parts for the URL
                const datePath = getDatePathFromIsoString(post.date);
                return (
                  <BlogCard 
                    key={post.slug} 
                    post={post} 
                    url={`/blog/${datePath}/${post.slug}`}
                  />
                );
              })}
            </div>
          ) : (
            <div className="rounded-lg bg-gray-800 p-8 text-center">
              <h2 className="mb-2 text-xl font-medium text-white">No articles yet</h2>
              <p className="text-gray-400">Check back soon for new content!</p>
            </div>
          )}
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default BlogIndex;
